import { Component } from '@angular/core';

@Component({
    selector: 'black-pen-character',
    templateUrl: '../../../../../../src/assets/svgs/characters/blackpen.svg',
    styleUrls: ['../svg.component.scss']
})
export class BlackPenCharacter {

}